import React, { useState } from 'react';
import Header from '../header/header'
import { Col, Card } from 'reactstrap';
import {
    Nav,
    NavItem,
    NavLink,
    TabContent,
    TabPane
} from 'reactstrap';

const NegativeScreening = ({camData}) => (
    <table style={{width: '100%'}}>
        <thead>
            <tr>
                <th style={{padding: '15px'}}>Entity</th>
                <th style={{padding: '15px'}}>Entity ID</th>
                <th style={{padding: '15px'}}>Entity Name</th>
                <th style={{padding: '15px'}}>Hit Count</th>
                <th style={{padding: '15px'}}>Hit Type</th>
                <th style={{padding: '15px'}}>Hit Source</th>
            </tr>
        </thead>
        <tbody style={{fontStyle: 'normal'}}>
            
            {camData.summary && camData.summary.negative_screening_data && camData.summary.negative_screening_data.length > 0 ?
            <>
               {camData.summary.negative_screening_data.map((NegativeData) => (
                   <tr>
                    <td style={{padding: '15px',background: '#fff'}}>
                        {NegativeData.comp_number && "Company"}
                        {NegativeData.cust_id && NegativeData.is_primary === true && "Applicant"}
                        {NegativeData.cust_id && NegativeData.is_primary === false && "Co-Applicant"}
                    </td>
                    <td style={{padding: '15px',background: '#fff'}}>
                        {NegativeData.comp_number}
                        {NegativeData.cust_id}
                    </td>
                    <td style={{padding: '15px',background: '#fff'}}>
                        {NegativeData.comp_number && <>{NegativeData.company_name}</>}
                        {NegativeData.cust_id && NegativeData.is_primary === true && <>{NegativeData.applicant_name}</>}
                        {NegativeData.cust_id && NegativeData.is_primary === false && <>{NegativeData.applicant_name}</>}
                    </td>
                    <td style={{padding: '15px',background: '#fff'}}>{NegativeData.trackwizz_company_hit_count}</td>
                    <td style={{padding: '15px',background: '#fff',textTransform: 'capitalize'}}>{NegativeData.trackwizz_hit_type ? NegativeData.trackwizz_hit_type.replaceAll("_"," ") : "-"}</td>
                    <td style={{padding: '15px',background: '#fff',textTransform: 'capitalize'}}>{NegativeData.trackwizz_hit_source ? NegativeData.trackwizz_hit_source.replaceAll("_"," ") : "-"}</td>
                   </tr>
               ))}                
            </>
            :
            <tr>
                <td style={{padding: '15px',background: '#fff',textAlign: 'center'}} colSpan={6}>No Data Found</td>
            </tr>
            }
        </tbody>
    </table>
);

const TypeTable = ({camData}) => (
    <table style={{width: '100%'}}>
        <thead>
            <tr>
                <th style={{padding: '15px'}}>Entity</th>
                <th style={{padding: '15px'}}>Entity ID</th>
                <th style={{padding: '15px'}}>Entity Name</th>
                <th style={{padding: '15px'}}>Risk Status</th>
            </tr>
        </thead>
        <tbody>
            {camData && camData.company_kyc_risk_summary && camData.company_kyc_risk_summary[0] &&
                <tr>
                    <td style={{border: '1px solid #dddddd',padding: '15px',background: '#fff'}}>Company</td>
                    <td style={{border: '1px solid #dddddd',padding: '15px',background: '#fff'}}>{camData.company_kyc_risk_summary[0].company_id || "-"}</td>
                    <td style={{border: '1px solid #dddddd',padding: '15px',background: '#fff'}}>{camData.company_kyc_risk_summary[0].company_name || "-"}</td>
                    <td style={{border: '1px solid #dddddd',padding: '15px',background: '#fff'}}>{camData.company_kyc_risk_summary[0].risk_status || "-"}</td>
                </tr>
            }
            {camData && camData.user_kyc_risk_summary && camData.user_kyc_risk_summary.map((userKyc) => (
                <tr>
                    <td style={{border: '1px solid #dddddd',padding: '15px',background: '#fff'}}>{userKyc.is_primary === true ? "Applicant" : "Co-Applicant"}</td>
                    <td style={{border: '1px solid #dddddd',padding: '15px',background: '#fff'}}>{userKyc.user_id || "-"}</td>
                    <td style={{border: '1px solid #dddddd',padding: '15px',background: '#fff'}}>{userKyc.user_name || "-"}</td>
                    <td style={{border: '1px solid #dddddd',padding: '15px',background: '#fff'}}>{userKyc.risk_status || "-"}</td>
                </tr>
            ))}           
            
        </tbody>
    </table>
);

const KycGrading = ({ camData, metaData, loanId }) => {
    const [activeTab, setActiveTab] = useState('1');

    const toggle = tab => {
        if (activeTab !== tab) setActiveTab(tab);
    };
    return (
        <>
            <Col md="12" className="pb-3">
                <Card>
                    <Header headerText="Reports" headerImg="/images/cam_version_3/black_file.svg" />
                </Card>
            </Col>
            <Col md="12" className="pb-3">
                <div className='LoanEligible'>
                <Nav tabs>
                    <NavItem>
                        <NavLink
                            className={`pt-3 pb-3 nav-link ${activeTab === '1' ? 'active' : ''}`}
                            onClick={() => toggle('1')}
                            href="#"
                        >
                            Negative Screening
                        </NavLink>
                    </NavItem>
                    <NavItem>
                        <NavLink
                            className={`pt-3 pb-3 nav-link ${activeTab === '2' ? 'active' : ''}`}
                            onClick={() => toggle('2')}
                            href="#"
                        >
                            KYC Risk Grading
                        </NavLink>
                    </NavItem>
                    {/* Add more tabs if needed */}
                </Nav>
                </div>
                <TabContent activeTab={activeTab} className="mt-0">
                    <TabPane tabId="1">
                        <NegativeScreening camData={camData}/>
                    </TabPane>
                    <TabPane tabId="2">
                        <TypeTable camData={camData} />
                    </TabPane>
                </TabContent>
            </Col>

        </>
    )
}
export default KycGrading;
